<template>
    <div>
        {{ place.location.lat }}, {{ place.location.lon }}<br>
        {{ place.location.words }}
    </div>
</template>

<script>
export default {
    name: 'place-location',
    props: ['place'],
    data() {
        return {
        }
    },
    created() {},
    computed: {
    },
    methods: {
    }
}
</script>
